if (!customElements.get('yqn-product-marquee')) {
  class YQNProductMarquee extends HTMLElement {
    connectedCallback() {
      if (this.dataset.mode !== 'slider') return;

      this.slides = Array.from(this.querySelectorAll('[data-yqn-slide]'));
      this.currentSlide = Math.max(
        0,
        this.slides.findIndex((slide) => slide.classList.contains('is-active'))
      );
      this.duration = Math.max(2000, Number(this.dataset.slideDuration) || 4000);
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.showSlide(this.currentSlide);
      if (this.reducedMotion) {
        this.dataset.reducedMotion = 'true';
        this.slides.forEach((slide) => slide.setAttribute('aria-hidden', 'false'));
        return;
      }
      if (this.slides.length < 2) return;

      this.start = this.start.bind(this);
      this.stop = this.stop.bind(this);
      this.addEventListener('mouseenter', this.stop);
      this.addEventListener('mouseleave', this.start);
      this.addEventListener('focusin', this.stop);
      this.addEventListener('focusout', this.start);
      this.start();
    }

    disconnectedCallback() {
      this.stop?.();
      this.removeEventListener('mouseenter', this.stop);
      this.removeEventListener('mouseleave', this.start);
      this.removeEventListener('focusin', this.stop);
      this.removeEventListener('focusout', this.start);
    }

    showSlide(index) {
      this.slides.forEach((slide, slideIndex) => {
        const isActive = slideIndex === index;
        slide.classList.toggle('is-active', isActive);
        slide.setAttribute('aria-hidden', String(!isActive));
      });
    }

    start() {
      this.stop();
      this.timer = window.setInterval(() => {
        this.currentSlide = (this.currentSlide + 1) % this.slides.length;
        this.showSlide(this.currentSlide);
      }, this.duration);
    }

    stop() {
      if (!this.timer) return;
      window.clearInterval(this.timer);
      this.timer = null;
    }
  }

  customElements.define('yqn-product-marquee', YQNProductMarquee);
}

if (!window.YQNOfferCopyReady) {
  window.YQNOfferCopyReady = true;

  const copyText = async (text) => {
    if (navigator.clipboard && window.isSecureContext) {
      try {
        await navigator.clipboard.writeText(text);
        return;
      } catch (error) {
        // Continue to the selection-based fallback when permission is denied.
      }
    }

    const field = document.createElement('textarea');
    field.value = text;
    field.setAttribute('readonly', '');
    field.style.position = 'fixed';
    field.style.opacity = '0';
    document.body.appendChild(field);
    field.select();
    const copied = document.execCommand('copy');
    field.remove();
    if (!copied) throw new Error('Copy command was not available');
  };

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-yqn-offer-copy]');
    if (!button) return;

    const code = button.dataset.yqnOfferCode;
    const feedback = button.querySelector('[data-yqn-copy-feedback]');
    if (!code || !feedback) return;

    try {
      await copyText(code);
      window.clearTimeout(button.yqnCopyTimer);
      button.dataset.copied = 'true';
      feedback.textContent = button.dataset.copiedLabel || 'Copied';
      button.setAttribute('aria-label', `${button.dataset.copiedLabel || 'Copied'}: ${code}`);
      button.yqnCopyTimer = window.setTimeout(() => {
        button.dataset.copied = 'false';
        feedback.textContent = button.dataset.copyLabel || 'Copy';
        button.setAttribute('aria-label', `${button.dataset.copyLabel || 'Copy'}: ${code}`);
      }, 2200);
    } catch (error) {
      button.dataset.copied = 'false';
      feedback.textContent = button.dataset.copyLabel || 'Copy';
    }
  });
}
